import { Country, UserShippingDetailsItem } from "../models";

export const getAccountAddress = (address: UserShippingDetailsItem, countries: Country[]): string => {
	const { countryId, address1, address2, city, state, zipCode } = address;
	const country = countries.find(country => country.id === countryId);
	return `${country?.name}, ${address1}, ${address2}, ${city}, ${state} ${zipCode}`;
};
